export const mapNewStateList = (id, data) => {
  if (!data.Id && !id) {
    console.log('Data Id Must be Provided');

    return (prevState) => prevState;
  }

  const mapId = id || data.Id;

  return (prevState) => {
    return prevState.map((prevData) =>
      prevData.Id !== mapId ? prevData : { ...prevData, ...data },
    );
  };
};

export const mapNewStateObject = (data) => {
  return (prevState) => {
    return {
      ...prevState,
      ...data,
    };
  };
};
